import { brandFromEnv, type BrandEnvValues } from '@icebreaker/shared/design';

/**
 * Panelin yapılandırması. SIR BURAYA GİRMEZ — bu değerler statik pakete
 * derleme anında gömülür ve tarayıcıya iner (`vite.config.ts` içindeki
 * `PUBLIC_ENV_KEYS` kapalı listesi).
 *
 * OKUMA DÜZ YAZIMLA yapılır (`process.env.APP_NAME`): Vite `define` ile
 * metinsel değiştirme yapar, dinamik erişim (`process.env[key]`) pakette
 * çözülmez. Aynı kısıt web tarafında da geçerlidir ve
 * `brand-env-parity.guard.spec.ts` orada makineyle denetlenir.
 */
/**
 * AYNI ORIGIN — ÇALIŞMA ZAMANINDA ÇÖZÜLÜR.
 *
 * `'/api'` gibi GÖRELİ bir taban adresi kullanılamaz: `ApiClient` isteği
 * `new URL(baseUrl + path)` ile kurar ve göreli dize tarayıcıda `Invalid URL`
 * fırlatır — oturum diriltme isteği hiç GÖNDERİLMEZ, panel de "karar
 * verilemedi" ekranında kalırdı (bu turda gerçek tarayıcıda ölçüldü).
 * Origin belge adresinden alınır: panel hangi host'tan servis edildiyse API
 * de o host'un `/api` yolundadır.
 */
const sameOriginApiUrl = (): string =>
  typeof window === 'undefined' ? 'http://localhost/api' : `${window.location.origin}/api`;

export const adminEnv = {
  /**
   * API kökü. VARSAYILAN AYNI ORIGIN: panel `admin.warmbreak.com`, API de o
   * host'un `/api` yolundadır — CORS yoktur ve oturum çerezi host'a özeldir.
   * Geliştirmede Vite dev sunucusu `/api`yi yerel API'ye vekiller.
   */
  apiUrl: process.env.ADMIN_API_URL ?? sameOriginApiUrl(),
  /*
   * MARKA — api sütunundaki anahtarlar. Panel için ÜÇÜNCÜ bir env ailesi
   * açılmadı; gerekçe `vite.config.ts` başındaki `PUBLIC_ENV_KEYS` yorumunda.
   */
  brand: {
    name: process.env.APP_NAME,
    shortName: process.env.APP_SHORT_NAME,
    domain: process.env.APP_PUBLIC_DOMAIN,
    publicDomain: process.env.APP_MARKETING_DOMAIN,
    supportEmail: process.env.BRAND_SUPPORT_EMAIL,
    logoLightUrl: process.env.BRAND_LOGO_LIGHT_URL,
    logoDarkUrl: process.env.BRAND_LOGO_DARK_URL,
    primary: process.env.BRAND_PRIMARY,
    accent: process.env.BRAND_ACCENT,
  } satisfies BrandEnvValues,
} as const;

/**
 * PANELİN MARKA TOKENLARI — TEK TÜRETME NOKTASI.
 * Ürün adı, logo ve renk buradan gelir; hiçbir ekrana sabitlenmez.
 */
export const adminBrand = brandFromEnv(adminEnv.brand);
